/**
 * Uses the constant to converts front-end data into format back-end can use for account confirmation
 *
 * @method secureFrontToBack
 * @param {Object} frontEndData Data to convert
 * @returns {Object} Converted data
 */
export const secureFrontToBack = (frontEndData) => {
    const allAccounts = frontEndData.accounts;
    const accountsToSend = [];
    for (const key in allAccounts) {
        if (allAccounts.hasOwnProperty(key)) {
            if (allAccounts[key] === true) {
                accountsToSend.push(+key);
            }
        }
    }
    const mappedData = {
        subject: frontEndData.subject,
        message: frontEndData.message,
        accounts: accountsToSend
    };
    return mappedData;
};



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/contact/dataConversion.ts